/**
 * A short notice over the 3D view (e.g. "WASM PyMOL could not be loaded; showing 3Dmol").
 *
 * Not a dialog on purpose: dialogs close on the app's 'escapeKey' event, which ModalManager
 * publishes whenever a modal opens - at start-up the entrance modal closed a fall-back notice
 * 100 ms after it appeared. This sits in the 3D view where the user is looking, goes away by
 * itself, and a click dismisses it earlier.
 */

const NoticeRole = 'viewer-notice';

/**
 * @param {string} text
 * @param {{ms?: number, parentId?: string}} [options] how long it stays (default 15 s)
 * @returns {HTMLElement|null} the notice element (null outside a browser)
 */
export function showViewerNotice(text, { ms=15000, parentId='canvas_wrapper' }={}) {
    if (typeof document === 'undefined') return null;
    const parent = document.getElementById(parentId);
    if (!parent) {
        console.warn(`3D viewer notice (no #${parentId}): ${text}`);
        return null;
    }
    hideViewerNotice(parentId);
    const elt = document.createElement('div');
    elt.setAttribute('role', 'status');
    elt.setAttribute('data-role', NoticeRole);
    elt.title = 'Click to dismiss';
    elt.textContent = text;
    // A light panel with a border reads on both color schemes (black and white 3D views);
    // bottom centre, above the color swatches and clear of the top-centre tour popup.
    Object.assign(elt.style, {
        position: 'absolute',
        left: '50%',
        bottom: '4.5em',
        transform: 'translateX(-50%)',
        width: 'max-content',
        maxWidth: 'min(38em, 70%)',
        padding: '0.55em 0.9em',
        borderRadius: '4px',
        border: '1px solid #ffb300',
        font: '13px sans-serif',
        lineHeight: '1.4',
        color: '#3e2723',
        background: 'rgba(255, 248, 225, 0.97)',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.45)',
        cursor: 'pointer',
        zIndex: '2',
    });
    elt.addEventListener('click', () => elt.remove());
    parent.appendChild(elt);
    setTimeout(() => elt.remove(), ms);
    return elt;
}

export function hideViewerNotice(parentId='canvas_wrapper') {
    if (typeof document === 'undefined') return;
    const parent = document.getElementById(parentId);
    if (parent) parent.querySelectorAll(`[data-role="${NoticeRole}"]`).forEach((e) => e.remove());
}
